module.exports = __webpack_public_path__ + "52a59d4ae2354bdf09da506922020f81.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/desk.jpg
// module id = 211
// module chunks = 0